// src/components/filter.
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";

import { Table, Col, Row, UncontrolledTooltip } from "reactstrap";
import AddEditModal from "../AddEdit/GenerateNorms";

//import components
import Breadcrumbs from "components/_Common/Breadcrumb";
import { useDispatch, useSelector } from "react-redux";

// actions
import { listChartColor, listGroupNorms } from "store/actions";
import { withTranslation } from "react-i18next";
import moment from "moment";

const List = (props) => {
  //meta title
  document.title = `${props.t("Group Norms")}  | ${props.t("Admin")}`;
  const navigate = useNavigate();
  const [modal, setModal] = useState(false);
  const [itemData, SetItemData] = useState();

  const { error, success, loading } = useSelector((state) => ({
    loading: state.Norms.loading,
    error: state.Norms.error,
    success: state.Norms.success,
  }));

  const dispatch = useDispatch();

  const [tableData, SetTableData] = useState([]);
  const [filterData, setFilterData] = useState({
    limit: 25,
    search: "",
  });

  const toggle = () => {
    if (modal) {
      setModal(false);
    } else {
      setModal(true);
    }
  };

  const fetchGroupNormsList = (filterData) => {
    dispatch(
      listGroupNorms(filterData, (res) => {
        if (res?.status === "success") {
          let modifiedList = res?.data?.map((dky) => ({
            value: dky.id,
            label: dky.norm_name,
            count: dky?.participants_count,
            createdAt: dky?.created_at,
          }));
          SetTableData(Array.isArray(res?.data) ? res?.data : []);
          setoptions(modifiedList);
          SetItemData({});
        }
      })
    );
  };
  useEffect(() => {
    fetchGroupNormsList(filterData);
  }, []);

  console.log(tableData);

  return (
    <React.Fragment>
      <div className="page-content table-main-config-chartcolor-list">
        <div className="container-fluid">
          <Breadcrumbs
            title={props.t("Norms")}
            breadcrumbItem={props.t("Group Norms")}
          />
          <AddEditModal
            modal={modal}
            toggle={toggle}
            itemData={itemData}
            fetchGroupNormsListData={() => fetchGroupNormsList(filterData)}
          />
          <Row>
            <Col md={12} className="text-end pe-0 mb-2">
              <div className="custm-btns">
                <button
                  onClick={() => {
                    setModal(true);
                    SetItemData({});
                  }}
                  className="btn btn-primary"
                >
                  {props.t("Generate Group Norms")}
                </button>
              </div>
            </Col>
          </Row>

          <Row>
            <Col lg="12">
              <div className="table-responsive">
                {loading ? (
                  <div className="loader d-flex justify-content-center align-items-center mt-5">
                    <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>{" "}
                    {props.t("Loading")}
                  </div>
                ) : (
                  <Table className="table mb-0">
                    <thead>
                      <tr>
                        <th className="main-data-fix-width">
                          {props.t("Norm Name")}
                        </th>
                        <th>{props.t("Participants Count")}</th>
                        <th>{props.t("Generate On")}</th>
                        <th>{props.t("Action")}</th>
                      </tr>
                    </thead>
                    {tableData && tableData?.length <= 0 ? (
                      <tr>
                        <td colSpan="5" className="text-center no-record-found">
                          {props.t("No Record Found")}
                        </td>
                      </tr>
                    ) : (
                      <tbody>
                        {(tableData && Array.isArray(tableData)
                          ? tableData
                          : []
                        )?.map((item, index) => (
                          <tr key={index}>
                            <td>{item?.norm_name}</td>
                            <td>{item?.participants_count}</td>
                            <td>
                              {moment(item?.created_at).format("DD/MM/YYYY")}
                            </td>
                            <td>
                              {/* <ul className="list-unstyled hstack gap-1 mb-0">
                                                                        <li> */}
                              <span
                                className="btn btn-sm btn-soft-info"
                                onClick={() => {
                                  navigate("/norms/group/questionnaire/list", {
                                    state: { batchData: item },
                                  });
                                }}
                              >
                                <i
                                  className="bx bx-file-find"
                                  id={`edittooltip${item?.id}`}
                                />
                                <UncontrolledTooltip
                                  placement="top"
                                  target={`edittooltip${item?.id}`}
                                >
                                  {props.t("View Norm")}
                                </UncontrolledTooltip>
                              </span>
                              {/* </li>
                                                                    </ul> */}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    )}
                  </Table>
                )}
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

List.propTypes = {
  history: PropTypes.object,
  t: PropTypes.any,
};

export default withTranslation()(List);
